import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../Stock/StockAnalysis/Redux/api";

// get sale
export const getSale = createAsyncThunk("sale/getSale", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getSale({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all sale
export const getAllSale = createAsyncThunk("sale/getAllSale", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllSale();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("sale/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("sale/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("sale/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageSale({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get item by id
export const getSaleById = createAsyncThunk("sale/getSaleById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getSaleById(id);
    if (data?.data.saleInvoiceDetails?.length > 0) {
      // get stock by id and branch
      const updatedDetailsPromises = data.data?.saleInvoiceDetails.map(async (detail) => {
        const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

        if (stockData.data?.length > 0) {
          return {
            ...detail,
            // availableStock stock from stockData
            availableStock: stockData.data[0]?.closingStock || "",
          };
        } else {
          return {
            ...detail,
            availableStock: 0,
          };
        }
      });

      const updatedDetails = await Promise.all(updatedDetailsPromises);
      return { ...data, data: { ...data.data, saleInvoiceDetails: updatedDetails } };
    } else {
      return data;
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create sale
export const createSale = createAsyncThunk("sale/createSale", async (createData, { rejectWithValue }) => {
  const { salesOrderMain, invoiceNo, refNo, voucherDate, narration, branch } = createData;
  try {
    const body = JSON.stringify({
      salesOrderMain,
      // invoiceNo,
      // refNo,
      voucherDate,
      narration,
      // branch,
    });

    const { data } = await API.createSale(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
export const updateSale = createAsyncThunk("sale/updateSale", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const {
    salesOrder,
    indentNo,
    isFromHo,
    requiredDateAd,
    voucherDate,
    branch,
    status,
    documentsAttach,
    // refVoucher,
    saleDetails,
  } = values;
  try {
    const body = JSON.stringify({
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      branch,
      status,
      voucherDate,
      // refVoucher,
      saleDetails,
    });
    const { data } = await API.updateSale(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// handle search
export const handleSearch = createAsyncThunk(
  "sale/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
